import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {CabinetResponse, CabinetSchema} from "../types/cabinet";
import {fetchCabinetData} from "../featchCabinetData/featchCabinetData";



const initialState: CabinetSchema = {
    readonly: true,
    isLoading: true,
    error: undefined,
    data: undefined,
};


export const cabinetSlice = createSlice({
    name: 'cabinet',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCabinetData.pending, (state) => {
                state.error = undefined;
                state.isLoading = true;
            })
            .addCase(fetchCabinetData.fulfilled, (
                state,
                action: PayloadAction<CabinetResponse>,
            ) => {
                state.isLoading = false;
                state.data = action.payload.data;
            })
            .addCase(fetchCabinetData.rejected, (state, action) => {
                state.isLoading = false;
                // @ts-ignore
                state.error = action.payload;
            });
    },
});

export const { actions: cabinetActions } = cabinetSlice;
export const { reducer: cabinetReducer } = cabinetSlice;
